import Model from './Model'

export default class Address extends Model {
    static async packageAddresses(query = null) {
        const config = {params: {query}}
        const {data} = await Http.get(route('api.v1.packages-addresses.index'), config)
        return this.make(data)
    }
}
